module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "detail-template"
    }
  }, [_vm._t("head", [_vm._v("HEAD")]), _vm._v(" "), _vm._t("body", [_vm._v("BODY")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-207a2063!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres32e/detailTemplate.vue
// module id = 3619
// module chunks = 1